<script>
  export default {
    data() {
      return {
        isLoading: false,
      }
    },
    methods: {
      onRefresh() {
        var that = this
        setTimeout(() => {
          window.location.reload();
          that.isLoading = false;
        }, 1000);
      },
      // 关闭页面
      closePage() {
        var _window = window
        try {
          _window.flutter_inappwebview.callHandler(
            "requestClosePageFromWeb",
            ""
          );
        } catch (error) {
          console.log(error);
        }
      },
      
      onClickLeft() {
        if(window.history.length > 1) {
          this.$router.go(-1); // 返回上一页
        }else {
          this.closePage()
        }
      },

      onClickLeft2() {
        if (!this.disabled) {
          this.isDialogVisible = true;
        } else {
          this.$router.go(-1); // 返回上一页
        }
      },

      //打开登录页面
      openLogin() {
        var _window = window
        try {
          _window.flutter_inappwebview.callHandler(
            "requestOpenLoginPageFromWeb",
            ""
          );
        } catch (error) {
          console.log(error);
        }
      },
      //打开小游戏
      openGame(id) {
        var _window = window
        var params = {id}
        try {
          _window.flutter_inappwebview.callHandler(
            "requestOpenGameFromWeb",
            JSON.stringify(params)
          );
        } catch (error) {
          console.log(error);
        }
      },
      //打开云手机
      openCloud() {
        var _window = window
        try {
          _window.flutter_inappwebview.callHandler(
            "requestCloudFromWeb",
            ""
          );
        } catch (error) {
          console.log(error);
        }
      },
      //打开游戏专区
      openGame(id) {
        var _window = window
        var params = {
          subRoute: '/community/singleZone',
          id
        }
        try {
          _window.flutter_inappwebview.callHandler(
            "requestOpenPageWithSubRouteAndParamFromWeb",
            JSON.stringify(params)
          );
        } catch (error) {
          console.log(error);
        }
      },
      //打开话题专区
      openGame(id) {
        var _window = window
        var params = {
          subRoute: '/community/singleTopicZone',
          id
        }
        try {
          _window.flutter_inappwebview.callHandler(
            "requestOpenPageWithSubRouteAndParamFromWeb",
            JSON.stringify(params)
          );
        } catch (error) {
          console.log(error);
        }
      },
    },
  }
</script>